module.exports = __webpack_public_path__ + "img/thin-vertical-line.836ee11d.svg";